import { CartControllerMode } from "@/data/model/Enums";
import { Signal, TypedSignal } from "@/data/util/Signal";

import { BaseController } from "@/app/controller/BaseController";

export class CartController extends BaseController {
    public onContinue?: { () };
    public onGoBack?: { () };

    static onInit = new Signal();
    static onShown = new Signal();
    static onHidden = new Signal();

    static onContinue = new Signal();
    static onGoBack = new Signal();

    static onUpdateMode = new TypedSignal<CartControllerMode>();

    constructor() {
        super("cart");

        CartController.onContinue.add(this.continue, this);
        CartController.onGoBack.add(this.goBack, this);

        CartController.onInit.dispatch();
    }

    protected onBecomeVisible() {
        CartController.onShown.dispatch();
    }

    protected onBecomeInvisible() {
        CartController.onHidden.dispatch();
    }

    public updateMode(mode: CartControllerMode) {
        CartController.onUpdateMode.dispatch(mode);
    }

    protected goBack() {
        if (this.onGoBack) {
            this.onGoBack();
        }
    }

    protected continue() {
        if (this.onContinue) {
            this.onContinue();
        }
    }
}
